module.exports = __webpack_public_path__ + "img/img-7.0260ed48.png";